module.exports = require("google-auth-library");